import { IOptInMethodTypes } from 'entities/Compliance/api/types/complianceType'

export enum TollFreeRoutes {
  root = 'toll-free',
  view = 'view',
  steps = 'steps',
  addNumber = 'add-number',
}

export enum TollFreeRoutesSteps {
  numbers = 'numbers',
  businessInfo = 'business-info',
  contactInfo = 'contact-info',
  useCase = 'use-case',
  optInMethod = 'opt-in-method',
  optInOnlineFormContent = 'opt-in-online-form-consent',
  optInPaperFormContent = 'opt-in-paper-form-consent',
  optInViaTextContent = 'opt-in-via-text-consent',
  optInQrCodeContent = 'opt-in-qr-code-consent',
  forbiddenMessageTopics = 'forbidden-message-topics',
  addTollFreeNumber = 'add-toll-free-number',
}

export const stepsToTypeIdMap = {
  [TollFreeRoutesSteps.optInOnlineFormContent]: 10,
  [TollFreeRoutesSteps.optInPaperFormContent]: 7,
  [TollFreeRoutesSteps.optInViaTextContent]: 9,
  [TollFreeRoutesSteps.optInQrCodeContent]: 8,
}

export const idToTypeMap = {
  10: TollFreeRoutesSteps.optInOnlineFormContent,
  7: TollFreeRoutesSteps.optInPaperFormContent,
  9: TollFreeRoutesSteps.optInViaTextContent,
  8: TollFreeRoutesSteps.optInQrCodeContent,
}

export const idToKeyMap: Record<number, IOptInMethodTypes> = {
  10: IOptInMethodTypes.onlineForm,
  7: IOptInMethodTypes.paperForm,
  9: IOptInMethodTypes.text,
  8: IOptInMethodTypes.qrCode,
}

export type StepsToTypeIdMap = {
  [key in
    | TollFreeRoutesSteps.optInOnlineFormContent
    | TollFreeRoutesSteps.optInPaperFormContent
    | TollFreeRoutesSteps.optInViaTextContent
    | TollFreeRoutesSteps.optInQrCodeContent]: number
}

export type IdToTypeMap = {
  [key in 7 | 8 | 9 | 10]:
    | TollFreeRoutesSteps.optInOnlineFormContent
    | TollFreeRoutesSteps.optInPaperFormContent
    | TollFreeRoutesSteps.optInViaTextContent
    | TollFreeRoutesSteps.optInQrCodeContent
}

export const IOptInMethodsMap: Partial<Record<TollFreeRoutesSteps, IOptInMethodTypes>> = {
  [TollFreeRoutesSteps.optInOnlineFormContent]: IOptInMethodTypes.onlineForm,
  [TollFreeRoutesSteps.optInPaperFormContent]: IOptInMethodTypes.paperForm,
  [TollFreeRoutesSteps.optInViaTextContent]: IOptInMethodTypes.text,
  [TollFreeRoutesSteps.optInQrCodeContent]: IOptInMethodTypes.qrCode,
}

export const IOptInYTypeMap: Partial<Record<IOptInMethodTypes, TollFreeRoutesSteps>> = {
  [IOptInMethodTypes.onlineForm]: TollFreeRoutesSteps.optInOnlineFormContent,
  [IOptInMethodTypes.paperForm]: TollFreeRoutesSteps.optInPaperFormContent,
  [IOptInMethodTypes.text]: TollFreeRoutesSteps.optInViaTextContent,
  [IOptInMethodTypes.qrCode]: TollFreeRoutesSteps.optInQrCodeContent,
}

export const optInTollFreeMethodTypes = {
  [IOptInMethodTypes.onlineForm]: 'WEB_FORM',
  [IOptInMethodTypes.paperForm]: 'PAPER_FORM',
  [IOptInMethodTypes.text]: 'VIA_TEXT',
  [IOptInMethodTypes.qrCode]: 'MOBILE_QR_CODE',
}

export const optInTollFreeMethodMap = {
  WEB_FORM: IOptInMethodTypes.onlineForm,
  PAPER_FORM: IOptInMethodTypes.paperForm,
  VIA_TEXT: IOptInMethodTypes.text,
  MOBILE_QR_CODE: IOptInMethodTypes.qrCode,
}

export enum TollFreeAddNumberRoutesSteps {
  Numbers = 'numbers',

  ChooseNumber = 'choose-number',
  AssignNumber = 'assign-number',
  Payment = 'payment',
}
